<div *ngIf="!isReceiveRegister">
    <div class="header">
        <div class="header-background">
            <div class="d-flex justify-content-between">
                <!-- Logo -->
                <div style="position: relative; z-index: 0;" *ngIf="loaded">
                    <img src="assets/images/register/Banner_Registro_4_Perfil.png" style="width: 100%;">
                </div>
            </div>
        </div>
    </div>
    
    <div *ngIf="user" class="background-default">
        <section id="wrapper">
            <div class="register">
    
                <div class="register-box" style="position: relative; z-index: 100;">
    
                    <app-register-account-form [user]="user" (onSave)="onSave($event)" (onCancel)="onCancel()"></app-register-account-form>
                </div>
            </div>
        </section>
    </div> 
</div>

<div *ngIf="isReceiveRegister && user">
    <app-register-account-form [user]="user" (onSave)="onSave($event)" (onCancel)="onCancel()"></app-register-account-form>
</div>

<div *ngIf="!user">
    <h5>Cargando la información de la cuenta ...</h5>
</div>
